import { render, staticRenderFns } from "./AsignarDescargoPage.vue?vue&type=template&id=9c86cf38"
import script from "./AsignarDescargoPage.js?vue&type=script&lang=js&external"
export * from "./AsignarDescargoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports